// src/redux/slices/permissionManagerSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk to fetch permissions for the logged-in employee
export const fetchPermissions = createAsyncThunk(
  "permissionManager/fetchPermissions",
  async (_, { rejectWithValue }) => {
    try {
      // Get userId from localStorage and treat it as employeeId
      const employeeId = localStorage.getItem("userId");

      if (!employeeId) {
        return rejectWithValue("No employeeId found in localStorage.");
      }

      const response = await axios.get(`https://payyug.in/api/permissions/${employeeId}`);
      const permissions = response.data.permissions || [];

      // Store only for the current session
      sessionStorage.setItem("userPermissions", JSON.stringify(permissions));

      return permissions;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const permissionManagerSlice = createSlice({
  name: "permissionManager",
  initialState: {
    data: [],
    loading: false,
    error: null
  },
  reducers: {
    clearPermissions: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
      sessionStorage.removeItem("userPermissions"); // clear on logout
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearPermissions } = permissionManagerSlice.actions;
export default permissionManagerSlice.reducer;
